@if (backgroundImageMobile ?? backgroundMobileImage) {
    <sirius-image-item
        [image]="backgroundImageMobile ?? backgroundMobileImage | cast"
        [imageData]="imageData"
        [fetchPriority]="'high'"
        objectFit="cover"
        objectPosition="bottom center"
        class="sir-image-mobile" />
}
@if (backgroundImageDesktop ?? backgroundDesktopImage) {
    <sirius-image-item
        [image]="backgroundImageDesktop ?? backgroundDesktopImage | cast"
        [imageData]="imageData"
        [fetchPriority]="'high'"
        objectPosition="bottom center"
        objectFit="cover"
        class="sir-image-desktop" />
}
<sirius-container>
    @if (variant) {
        <div class="sir-text-container">
            <div class="sir-text">
                <sirius-heading
                    [text]="title"
                    textStyleCategory="display"
                    textStyleSize="m"
                    data-cy="hero-heading"></sirius-heading>

                @if (textHtml) {
                    <sirius-text-html
                        class="sir-sub-title"
                        [html]="textHtml"
                        textStyleSize="l"
                        data-cy="hero-texthtml"></sirius-text-html>
                }
            </div>
            @if (buttonPrimary || buttonSecondary) {
                <div class="sir-buttons">
                    @if (buttonPrimary) {
                        <a
                            siriusButton
                            [siriusLink]="buttonPrimary.link"
                            [iconName]="buttonPrimary.iconName"
                            [buttonText]="buttonPrimary.link.title"
                            [buttonType]="buttonType"
                            data-cy="hero-btn-primary"></a>
                    }
                    @if (buttonSecondary) {
                        <a
                            siriusButton
                            [size]="'small'"
                            [siriusLink]="buttonSecondary.link"
                            [iconName]="buttonSecondary.iconName"
                            [buttonText]="buttonSecondary.link.title"
                            [buttonType]="buttonType"
                            data-cy="hero-btn-secondary"></a>
                    }
                </div>
            }
        </div>
    }
</sirius-container>
